export default function ({state, commit}, {value}) {
    if (value) {
        commit('filter_remove', value);
        if (!state.filters.length) commit('filter_add');
    } else {
        commit('filter_add');
    }
}